// Indian numbering system money formatter.
export function formatINR(v) {
  if (v === null || v === undefined || v === "") return "—";
  const n = typeof v === "number" ? v : parseFloat(String(v).replace(/,/g, ""));
  if (isNaN(n)) return v;
  const neg = n < 0;
  const x = Math.abs(n);
  const hasDec = x % 1 !== 0;
  const fixed = x.toFixed(hasDec ? 2 : 0);
  let [ip, dp] = fixed.split(".");
  let last3 = ip.slice(-3);
  let rest = ip.slice(0, -3);
  if (rest) {
    last3 = "," + last3;
    rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  }
  return (neg ? "-" : "") + "₹" + rest + last3 + (dp ? "." + dp : "");
}

export const MONEY_FIELDS = new Set([
  "amount", "value", "estimated_value", "rate", "current_rate", "monthly_rate",
  "monthly_payment", "daily_rate", "contract_value", "purchase_cost", "amount_paid",
  "invoice_value", "outstanding", "advance_amount", "payment_in", "payment_out",
  "balance", "net_paid", "material_value", "total_sales", "total_monthly_payment",
  "net_balance", "pending_payments",
]);
